import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import ResidencyStatusService from "../../../Services/ResidencyStatus.service";
import ResidencyStatusLookupModal from "./ResidencyStatusLookupModal";
const makeSearchArgs = {
    loadOptions: (search, options) => ResidencyStatusService.search({
        ids: options === null || options === void 0 ? void 0 : options.ids,
        query: search || (options === null || options === void 0 ? void 0 : options.query),
        names: options === null || options === void 0 ? void 0 : options.names,
        srcSystemIds: options === null || options === void 0 ? void 0 : options.srcSystemIds,
    }, { max: 20 }).then(({ data }) => data),
    label: "name",
    value: "id",
};
export const ResidencyStatusSearch = makeSearch(makeSearchArgs);
export const ResidencyStatusMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, makeSearchArgs), { 
    // @ts-expect-error - TS2322 - Type 'ComponentType<WithModalParams<LookupModalProps<ResidencyStatus, any>>>' is not assignable to type 'ComponentType<never> | undefined'.
    lookupModal: ResidencyStatusLookupModal }));
